import { Min } from 'class-validator';

export class AuctionOfferModel {
  @Min(1)
  public price: number;

  constructor(
    price: number
  ) {
    this.price = price;
  }
}
